import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getItemToken } from '../../../Utils/localStorageUtils';
import axios from 'axios';

const LandingPreview = () => {
    const { id } = useParams();
    const baseURL = process.env.REACT_APP_Baseurl;
    const headers = getItemToken('access_token');
    const editApi = `${baseURL}/admin/landing-page/edit`;

    const [iframeSrc, setIframeSrc] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            const response = await axios.get(`${editApi}/${id}`, { headers });
            const result = response?.data?.data;

            if (result) {
                const fullHTML = `
                    <!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8" />
                        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                        <script src="https://cdn.tailwindcss.com"><\/script>
                        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800;900&display=swap" rel="stylesheet">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />
                        <style>${result.custom_css || ''}</style>
                    </head>
                    <body>
                        ${result.content || ''}
                        <script src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"><\/script>
                        <script>
                            document.addEventListener('DOMContentLoaded', function () {
                                // Swiper init
                                if (typeof Swiper !== 'undefined') {
                                    new Swiper('.mySwiper', {
                                        slidesPerView: 2,
                                        spaceBetween: 16,
                                        pagination: { el: '.swiper-pagination', clickable: true },
                                        breakpoints: {
                                            640: { slidesPerView: 3 },
                                            1024: { slidesPerView: 4 },
                                        }
                                    });
                                }
                                // Mobile nav toggle
                                const toggle = document.getElementById('navToggle');
                                const drawer = document.getElementById('navDrawer');
                                if (toggle && drawer) {
                                    toggle.addEventListener('click', () => {
                                        drawer.classList.toggle('hidden');
                                    });
                                }
                            });
                        <\/script>
                    </body>
                    </html>
                `;
                setIframeSrc(fullHTML);
            }
        } catch (error) {
            console.error("Error fetching landing page data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchData();
    }, [id]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <p>Loading preview...</p>
            </div>
        );
    }

    return (
        <iframe
            srcDoc={iframeSrc}
            style={{
                width: '100%',
                border: 'none',
                display: 'block',
                minHeight: '100vh',
            }}
            title="Landing Page Preview"
            onLoad={(e) => {
                // Auto-resize iframe height to match content
                try {
                    const height = e.target.contentDocument.body.scrollHeight;
                    if (height > 0) e.target.style.height = height + 'px';
                } catch (_) {}
            }}
        />
    );
};

export default LandingPreview;